/** リトライ設定 */
export class ApiRetrySetting {
    static readonly COUNT = 3;
    static readonly TIMEOUT = 60000; // 60秒
}
